import videojs from 'video.js';

import controlsTemplate from 'bundles/videojs/layout/controls.html';
import 'bundles/videojs/plugins/subtitlesMenuItem';

class SubtitlesOffMenuItem extends videojs.getComponent('SubtitlesMenuItem') {
  constructor(player, options) {
    super(player, {
      ...options,
      track: {
        kind: 'subtitles',
        player,
        label: controlsTemplate({
          controlName: 'subtitlesOffLabel',
        }),
        dflt: false,
        mode: false,
      },
      selectable: true,
    });
    this.selected(true);
  }
}
videojs.registerComponent('SubtitlesOffMenuItem', SubtitlesOffMenuItem);
